import React from 'react';
import { DatePicker, Space } from 'antd';
import moment from 'moment';
import { useFormikContext } from 'formik';

type Props = {
  name: string;
  format: string;
  cellDate: string;
};

const AntDatePicker: React.FC<Props> = ({ format, name, cellDate }) => {
  const { setFieldValue, values } = useFormikContext();
  // @ts-ignore
  return (
    <Space className="w-140" direction="vertical">
      <DatePicker
        className="w-140"
        name={name}
        disabledDate={(current) => {
          const splitDate = cellDate.split('.');
          const date = new Date(`${splitDate[2]}, ${splitDate[1]}, ${splitDate[0]}`);
          const customDate = date;
          return current && current < moment(customDate, 'YYYY-MM-DD');
        }}
        format={format}
        // @ts-ignore
        onChange={(dateString: string) => setFieldValue(`${name}`, dateString)}
        showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
        getPopupContainer={(triggerNode) => triggerNode!.parentNode as HTMLElement}
        // @ts-ignore
        disabled={
          // @ts-ignore
          (name === 'from' && values?.vertical) ||
          // @ts-ignore
          (name === 'to' && values?.horizontal) ||
          // @ts-ignore
          values?.day ||
          // @ts-ignore
          (values?.horizontal === '' && values?.vertical === '')
        }
      />
    </Space>
  );
};

export default AntDatePicker;
